<template>
    <div class="suggest">
        <div class="auto">
            <breadcrumb />
            <h2 class="title">評價司機</h2>
            <el-form ref="form" label-width="96px" :label-position="labelPosition">
                <el-form-item label="乘車人">
                    <el-input v-model="user" class="input"></el-input>
                </el-form-item>
                <el-form-item label="聯絡 E-mail">
                    <el-input v-model="email" class="input"></el-input>
                </el-form-item>
                <el-form-item label="司機名">
                    <el-input v-model="driver" class="input"></el-input>
                </el-form-item>
                <el-form-item label="評分">
                    <el-rate v-model="score" class="score"></el-rate>
                </el-form-item>
                <el-form-item label="建議(選填)" class="input">
                    <el-input type="textarea" v-model="content" rows="4"></el-input>
                </el-form-item>
                <div class="section">感謝您的寶貴意見!</div>
                <el-form-item>
                    <el-button type="success" @click="submit" class="btn">送出</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb/index.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'suggest',
    components: {
        breadcrumb
    },
    computed: {
        ...mapGetters(['labelPosition']),
        user: {
            get() {
                return this.$store.state.suggest.user;
            },
            set(val) {
                this.$store.commit('SUGGESTUSER', val);
            }
        },
        email: {
            get() {
                return this.$store.state.suggest.email;
            },
            set(val) {
                this.$store.commit('SUGGESTEMAIL', val);
            }
        },
        driver: {
            get() {
                return this.$store.state.suggest.driver;
            },
            set(val) {
                this.$store.commit('SUGGESTDRIVER', val);
            }
        },
        score: {
            get() {
                return this.$store.state.suggest.score;
            },
            set(val) {
                this.$store.commit('SUGGESTSCORE', val);
            }
        },
        content: {
            get() {
                return this.$store.state.suggest.content;
            },
            set(val) {
                this.$store.commit('SUGGESTCONTENT', val);
            }
        }
    },
    methods: {
        submit() {}
    }
};
</script>
<style lang="scss" scoped>
.suggest {
    font-family: '微軟正黑體', sans-serif;
    background-color: #f1f1f1;
    .auto {
        width: 1440px;
        margin: auto;
        display: flex;
        flex-direction: column;
        @media screen and (max-width: 1440px) {
            width: 1224px;
        }
        @media screen and (max-width: 1224px) {
            width: 96%;
        }
        h2 {
            color: #999;
            font-size: 24px;
            line-height: 40px;
            font-weight: 700;
            padding: 0 0 0 16px;
            margin: 8px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                margin: auto;
                background-color: #999;
                width: 4px;
                height: 24px;
            }
        }
        form {
            width: 800px;
            padding: 16px;
            margin: 0 0 40px 0;
            background: #f7f7f7;
            align-self: center;
            @media screen and (max-width: 1224px) {
                width: 96%;
            }
        }
        .section {
            text-align: center;
            font-size: 12px;
            margin: 0 0 16px 0;
        }
        .el-form-item__content {
            display: flex;
            align-items: center;
        }
        .score {
            transform: translateY(10px);
            @media screen and (max-width: 1224px) {
                transform: translateY(0);
            }
        }
    }
}
</style>